import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import makeTheme from '~/assets/styles/makePrimaryColorTheme';

import CheckBox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { ThemeProvider } from '@material-ui/styles';

function InputCheckBox(props){
  const {color, children, label, value, onChange, labelPlacement, ...ownProps} = props;
  const theme = useMemo(() => makeTheme(color));

  return(
    <ThemeProvider theme={theme}>
      <FormControlLabel
        {...ownProps}
        control={
        <CheckBox
          checked={value}
          onChange={onChange}
          color='primary'
        />
        }
        label={label}
        labelPlacement={labelPlacement}
        color='primary'
      />
    </ThemeProvider>
  );
}

InputCheckBox.propTypes = {
  color: PropTypes.any,
  className: PropTypes.node,
  label: PropTypes.string,
  labelPlacement: PropTypes.string.isRequired,
};

InputCheckBox.defaultProps={
  labelPlacement: 'end',
};

export default InputCheckBox;
